import React from 'react';
import { Handle, Position } from 'reactflow';
import { theme } from '../../theme';

interface GridNodeData {
  label: string;
  description?: string;
  color?: string;
}

interface GridNodeProps {
  data: GridNodeData;
}

const GridNode: React.FC<GridNodeProps> = ({ data }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '4px',
    }}>
      {/* Main component */}
      <div
        style={{
          display: 'inline-flex',
          width: '40px',
          height: '40px',
          padding: '8px',
          justifyContent: 'center',
          alignItems: 'center',
          flexShrink: 0,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: '8px',
          position: 'relative',
          backgroundColor: 'white',
        }}
      >
        <img
          src={process.env.PUBLIC_URL + '/grid.svg'}
          alt="Grid"
          style={{
            width: '24px',
            height: '24px',
          }}
        />
        
        {/* Output handle on the right */}
        <Handle
          type="source"
          position={Position.Right}
          style={{
            background: theme.palette.success.main,
            width: '8px',
            height: '8px',
          }}
        />
      </div>
      
      {/* Component information */}

    </div>
  );
};

export default GridNode;
